import React from "react";
import InstagramPostCard from "./SocianMEdicaCard";
import "./SocialMedia.css";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

function SocialMedia() {
  const links = [
    "https://www.instagram.com/reel/DAOHJEKytiL/",
    "https://www.instagram.com/reel/CeqqcvWp2hu/",
    "https://www.instagram.com/reel/CB8EVyvHRB1/",
    "https://www.instagram.com/reel/CM4jkC2HcYg/"
  ];

  const [sliderRef] = useKeenSlider({
    loop: true,
    mode: "free-snap",
    slides: {
      perView: 2,
      spacing: 15,
    },
    breakpoints: {
      "(max-width: 768px)": {
        slides: {
          perView: 1,
          spacing: 10,
        },
      },
    },
  });

  return (
    <section className="py-12 px-4 md:px-10 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
          Follow us on social media
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base mb-10">
          Lorem ipsum dolor sit amet consectetur nullam consectetur turpis consectetur mattis fames sit eu tempus molestie.
        </p>
      </div>

      {/* Keen Slider Container */}
      <div ref={sliderRef} className="keen-slider">
        {links.map((link, index) => (
          <div className="keen-slider__slide" key={index}>
            <InstagramPostCard link={link} />
          </div>
        ))}
      </div>
    </section>
  );
}

export default SocialMedia;
